// src/components/LoginLogo.js
import { useStyletron } from 'baseui'

export default function ConfirmIcon({ styles }) {
  const [css] = useStyletron()
  return (
    <div
      className={css({
		transformOrigin: 'center',
        ...styles,
      })}
    >
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" fill="#F2372D"/>
        <path d="M15.0118 19.1091L14.0235 11.2545V7H17.9765V11.2545L16.9882 19.1091H15.0118ZM14 25V20.7706H18V25H14Z" fill="white"/>
      </svg>
    </div>
  )
}
